import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getExchanges,
  changeStatusExchange,
} from "../../../../api/exchange";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";

function getData(exchanges) {
  let data = [];
  for (let i = 0; i < exchanges.length; ++i) {
    const elem = {};
    elem.id = exchanges[i]._id;
    elem.name = exchanges[i].fullName;
    elem.active = exchanges[i].active;
    data = data.concat(elem);
  }
  return data;
}
export default function ExchangesPage() {
  const [data, setData] = useState([]);
  const [exchangeId, setExchangeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [exchanges, setExchanges] = useState([]);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-exchange/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setExchangeId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Full Name", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getExchanges()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setExchanges(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get exchanges.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Exchanges list">
          <CardHeaderToolbar>
            {/* <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-exchange")}
            >
              Add new
            </button> */}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>

          <Table data={getData(exchanges)} columns={columns} />

          <ConfirmDialog
            title={`Are you sure you want to ${
              exchangeId?.active ? "disable" : "enable"
            } this exchange?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusExchange(exchangeId._id, !exchangeId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${exchangeId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Exchange ${
                        exchangeId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      exchangeId?.active ? "disable" : "enable"
                    } exchange.`,
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
